import { Toaster as Sonner } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      closeButton // 1. Added the closeButton prop here
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-gray-600",
          actionButton:
            "group-[.toast]:bg-blue-600 group-[.toast]:text-white group-[.toast]:rounded-lg",
          cancelButton: "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-600",
          // 2. Added styling for the close button to match your theme
          closeButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-500 group-[.toast]:hover:text-gray-900 group-[.toast]:hover:bg-gray-200 group-[.toast]:border-gray-200",
          // Enhanced success toast - vibrant green
          success:
            "group-[.toaster]:!bg-green-50 group-[.toaster]:!border-green-300 group-[.toaster]:!text-green-900 [&>div]:!text-green-700",
          // Enhanced error toast - vibrant red
          error:
            "group-[.toaster]:!bg-red-50 group-[.toaster]:!border-red-300 group-[.toaster]:!text-red-900 [&>div]:!text-red-700",
          warning: "group-[.toaster]:bg-yellow-50 group-[.toaster]:border-yellow-200",
          info: "group-[.toaster]:bg-blue-50 group-[.toaster]:border-blue-200",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
